import tmhRequest from '@/config/tmhRequest'

export default {
    searchListMemberStatusReport: function (data) {
        return tmhRequest({
            url: '/report/ispa/memberstatusreport/searchlistmemberstatusreport',
            method: 'post',
            data: data,
        })
    },
    searchMemberAnalysisReportByPage: function (data) {
        return tmhRequest({
            url: '/report/ispa/memberanalysisreport/searchmemberanalysisreportbypage',
            method: 'post',
            data: data,
        })
    },
    exportMemberStatusReport: function (data) {
        return tmhRequest({
            url: '/report/ispa/memberstatusreport/exportmemberstatusreport',
            method: 'post',
            responseType: 'blob',
            data: data,
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/ispa/report/memberstatusreport.js